import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { IntegrationParameterTypeT } from 'routes/IntegrationsList/types';
import Typography from '@mui/material/Typography';

type Props = { parameterType: IntegrationParameterTypeT };

const ParameterExampleValue = ({
    parameterType,
}: Props): React.ReactElement => {
    const { t } = useTranslation();

    let exampleValue;
    let exampleTraduction = 'parameterFieldExample';
    switch (parameterType) {
        case 'str':
            exampleValue = 'exemple';
            break;
        case 'date_str':
            exampleValue = 'yyyy-mm-dd';
            break;
        case 'number':
            exampleValue = '1.618';
            break;
        case 'list[str]':
            exampleValue = '[exemple, autre_exemple]';
            break;
        case 'list[number]':
            exampleValue = '[12, 34]';
            break;
        case 'list[bool]':
            exampleValue = '[true, false]';
            break;
        default:
            // for 'bool' and 'variant' cases
            exampleTraduction = 'parameterSelectorExample';
    }
    return (
        <Typography className="example-value">
            <i>{t(`cellar.${exampleTraduction}`)}</i> {exampleValue}
        </Typography>
    );
};

export default ParameterExampleValue;
